"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconFurnituresThematic = void 0;
var React = __importStar(require("react"));
var IconFurnituresThematic = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M10.5,11 L13.232,11 L15.084,8.223 C15.237,7.992 15.549,7.933 15.777,8.084 C16.007,8.237 16.069,8.548 15.916,8.777 L14.435,11 L15.232,11 L17.084,8.223 C17.237,7.992 17.55,7.933 17.777,8.084 C18.007,8.237 18.069,8.548 17.916,8.777 L16.435,11 L17.232,11 L19.084,8.223 C19.238,7.992 19.55,7.933 19.777,8.084 C20.007,8.237 20.069,8.548 19.916,8.777 L18.435,11 L21,11 L21,7 L3,7 L3,11 L10.5,11 C10.5953,11 10.6923,10.973 10.7773,10.916 L13.7773,8.916 C14.0063,8.763 14.0693,8.452 13.9163,8.223 C13.7613,7.992 13.4503,7.932 13.2223,8.084 L10.2223,10.084 C9.9933,10.237 9.9303,10.548 10.0843,10.777 C10.1802404,10.9219099 10.3391025,10.9999031 10.5,10.9999999 Z M12.5,20 L21,20 L21,12 L12.5,12 L12.5,20 Z M3,20 L11.5,20 L11.5,12 L3,12 L3,20 Z M3.5,3 C3.225,3 3,3.225 3,3.5 L3,6 L4.691,6 L4.053,4.724 C3.93,4.477 4.029,4.177 4.276,4.053 C4.523,3.93 4.823,4.029 4.947,4.276 L5.809,6 L6.691,6 L6.053,4.724 C5.93,4.477 6.029,4.177 6.276,4.053 C6.524,3.93 6.823,4.029 6.947,4.276 L7.809,6 L8.691,6 L8.053,4.724 C7.93,4.477 8.029,4.177 8.276,4.053 C8.524,3.93 8.823,4.029 8.947,4.276 L9.809,6 L21,6 L21,3.5 C21,3.225 20.775,3 20.5,3 L3.5,3 Z M22,3.5 L22,21 L19,21 L19,21.5 C19,21.776 18.776,22 18.5,22 C18.224,22 18,21.776 18,21.5 L18,21 L6,21 L6,21.5 C6,21.776 5.776,22 5.5,22 C5.224,22 5,21.776 5,21.5 L5,21 L2,21 L2,3.5 C2,2.673 2.673,2 3.5,2 L20.5,2 C21.327,2 22,2.673 22,3.5 Z M14.5,14 C14.776,14 15,14.224 15,14.5 L15,17.5 C15,17.776 14.776,18 14.5,18 C14.224,18 14,17.776 14,17.5 L14,14.5 C14,14.224 14.224,14 14.5,14 Z M9.5,18 C9.224,18 9,17.776 9,17.5 L9,14.5 C9,14.224 9.224,14 9.5,14 C9.776,14 10,14.224 10,14.5 L10,17.5 C10,17.776 9.776,18 9.5,18 Z" }))); };
exports.IconFurnituresThematic = IconFurnituresThematic;
exports.IconFurnituresThematic.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconFurnituresThematic;
